import React from 'react';

export const CellElement: React.FC<
  React.TdHTMLAttributes<HTMLTableCellElement>
> = ({ style, ...rest }) => {
  const mergedStyle = style
    ? { ...style, border: '0 none', borderRadius: 0 }
    : { border: '0 none', borderRadius: 0 };

  return <td {...rest} style={mergedStyle} />;
};

export const RowElement: React.FC<
  React.HTMLAttributes<HTMLTableRowElement>
> = ({ style, ...rest }) => {
  const mergedStyle = style
    ? { ...style, border: '0 none' }
    : { border: '0 none' };
  return <tr {...rest} style={mergedStyle} />;
};
